import 'babel-polyfill'
import Vue from 'vue'
import VueRouter from 'vue-router'
import Vuelidate from 'vuelidate'
import ArchiiComponents from 'archii-web-components'
import App from './App.vue'
import * as uiv from 'uiv'
import SignupModal from '@/comps/SignupModal/plugin'
import { setupAnalytics } from '@/utils'
import Config from 'config' // webpack alias
import store from './store'
import router from './router'

setupAnalytics(router)

Vue.use(VueRouter)
Vue.use(SignupModal)
Vue.use(Vuelidate)
Vue.use(ArchiiComponents)
Vue.use(uiv, { prefix: 'uiv' })

var Api = new ArchiiComponents.Api({
    api: {
        server: Config.baseURI
    }
}, new ArchiiComponents.Logger({
    module: 'api',
    bg: 'olive',
    level: Config.logLevel,
    trace: Config.traceLevel
}))

Vue.prototype.$Api = Api
Vue.$Api = Api
Vue.prototype.$Config = Config

new Vue({
    components: { App },
    router,
    store,
    template: '<App/>'
}).$mount('#app')


// WEBPACK FOOTER //
// ./apps/account/app.js